import { render, staticRenderFns } from "./addCaseDialog.vue?vue&type=template&id=a521fd40"
import script from "./addCaseDialog.vue?vue&type=script&lang=js"
export * from "./addCaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports